import { Mobile, Pc } from '../../hooks/MediaQuery'
import Page4Pc from './Page4Pc'
import Page4Mobile from './Page4Mobile'
import { useEffect, useState } from 'react'
import { selectItemsList } from '../../api/x_item'
import { useParams } from 'react-router-dom'

function Page4() {
  const [items, setItems] = useState()
  let { gsId, itemId } = useParams()

  useEffect(() => {
    async function fetchItemsData() {
      const response = await selectItemsList({ useYn: 'Y', gsSeq: gsId })
      const data = response.data.data
      setItems(data)
    }
    fetchItemsData()
  }, [])
  return (
    <>
      <Pc>{items && <Page4Pc items={items} itemId={itemId} />}</Pc>
      <Mobile>{items && <Page4Mobile items={items} itemId={itemId} />}</Mobile>
    </>
  )
}

export default Page4
